import { createUseStyles } from "$utils/createUseStyles";
import { theme } from "$utils/theme/bataillog";

const useStyles = createUseStyles(() => ({
  title: {
    margin: 0,
    paddingLeft: theme.spacing(1),
  },
  subCat: {
    fontWeight: 600,
  },
  paddingLeft: {
    paddingLeft: 24,
  },
  flexLine: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between !important",
    width: "100%",
    borderBottom: "1px solid #ddd",
  },
  flexLineLeft: {
    display: "flex",
    alignItems: "center",
  },
  productUl: {
    listStyle: "none",
    paddingLeft: theme.spacing(12),
    "& li": {
      padding: [2, 0],
    },
  },
  muiList: {
    "& .MuiListItem-root": {
      paddingTop: 2,
      paddingBottom: 2,
    },
  },
  textId: {
    marginLeft: theme.spacing(2),
    display: "inline",
  },
}));

export default useStyles;
